import React, { useState } from 'react';
import logComponent from '../../common/logComponent';
import './TruncateText.css';

export default function TruncateText({ text, truncateAt }) {
  const [requiresTruncation, setRequiresTruncation] = useState(text.split(' ').length > truncateAt);
  const [truncated, setTruncated] = useState(true);

  if (logComponent('TruncateText')) { console.debug('TruncateText rendered'); }

  const truncate = (textToTruncate, words) => {
    let truncatedText = textToTruncate.split(' ')
               .filter(item => item.trim().length !== 0)
               .filter((item, index) => index < words)
               .join(' ');

    
    return truncatedText + '...';
  }
  const [truncatedText, setTruncatedText] = useState(truncate(text, truncateAt));

  
  const toggleTruncation = () => {
    if (logComponent('TruncateText')) { console.debug('TruncateText toggleTruncation'); }
    setTruncated(!truncated);
  }

  return (
    <p className="Truncate-Text">
      {
        !requiresTruncation ?
          text :
          (truncated ?
            truncatedText :
            text)
      }
      {
        requiresTruncation &&
        <button
          className="Truncate-Text__toggle"
          onClick={toggleTruncation}>
          {
            truncated ?
              'See more' :
              'See less'
          }
        </button>
      }
    </p>
  );
}
